<template>
    <v-container>
        <v-stepper v-model="step" :class="'fill-height'">
            <v-stepper-header>
                <v-stepper-step :complete="step > 1" step="1" @click="{}">
                    Informations du patient
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2" @click="{}">
                    Cas
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 3" step="3" @click="{}">
                    Diagnostique
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 4" step="4" @click="{}">
                    Traitement
                </v-stepper-step>
                <v-divider></v-divider>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-form ref="patientForm" v-model="patientInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md10 offset-md1>
                                <h3 class="headline mb-4">Informations du patient</h3>
                                <v-select
                                    v-model="gender"
                                    :items="[{text: 'Homme', value: 'male'}, {text: 'Femme', value: 'female'}, {text: 'Indéfini', value: 'undefined'}]"
                                    label="Sexe"
                                    :rules="genderRules"
                                    required
                                ></v-select>
                                <v-text-field
                                    v-model="firstname"
                                    :rules="nameRules"
                                    label="Prénom"
                                    required>
                                </v-text-field>
                                <v-text-field
                                    v-model="lastname"
                                    :rules="nameRules"
                                    label="Nom"
                                    required>
                                </v-text-field>
                                <v-text-field v-if="!noEmail" :rules="emailRules"
                                              :value="email ? email.toLowerCase() : ''"
                                              @input="(value) => { value ? setEmail(value.toLowerCase()) : null }"
                                              label="Email"></v-text-field>

                                <v-checkbox
                                    v-model="noEmail"
                                    color="primary"
                                    label="Pas d'adresse email"
                                    class="mb-2 mt-0"
                                >
                                </v-checkbox>
                                <v-text-field v-model="phone" label="Téléphone"></v-text-field>
                                <v-menu
                                    ref="showDatePicker"
                                    v-model="showDatePicker"
                                    :close-on-content-click="false"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="birthDateFormatted"
                                            label="Date de naissance"
                                            append-icon="event"
                                            v-on="on"
                                            :rules="dateRules"
                                            @blur="birth_date = parseDate(birthDateFormatted)"
                                            required
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker ref="birthdayPicker"
                                                   locale="fr"
                                                   v-model="birth_date"
                                                   :max="new Date().toISOString()"
                                                   no-title @input="showDatePicker = false"></v-date-picker>
                                </v-menu>

                                <v-text-field
                                    v-model="opaleNumber"
                                    label="Numéro OPALE"
                                    :rules="opaleNumberRules"
                                >
                                </v-text-field>

                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3 text-xs-right>
                                <v-btn :disabled="!patientInfoValid" color="success" @click="validate">Suivant</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-form ref="newMedicalCaseForm" v-model="medicalCaseInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md10 offset-md1>
                                <h3 class="headline mb-4">Création d'un cas pour {{ firstname }} {{ lastname }}</h3>
                                <v-card-text>
                                    <v-select
                                        v-model="newMedicalCaseName"
                                        :rules="medicalCaseRules"
                                        :items="[
                                            {text: 'Gonalgies droites', value: 'Gonalgies droites'},
                                            {text: 'Gonalgies gauches', value: 'Gonalgies gauches'},
                                        ]"
                                        label="Nom du cas"
                                        required
                                    ></v-select>
                                </v-card-text>
                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn :disabled="!medicalCaseInfoValid" color="success" @click="validateMedicalCase"
                                       class="right">
                                    Suivant
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="3">

                    <v-form ref="diagnosticForm" v-model="diagnosticInfoValid" lazy-validation>

                        <v-layout>
                            <v-flex md10 offset-md1>
                                <div>
                                    <h3 class="headline mb-4">Ajouter un diagnostique</h3>
                                    <v-flex xs12>
                                        <v-select
                                                  v-model="diagnosticType"
                                                  :rules="[v => !!v || 'Item is required']"
                                                  :items="getDiagnosticTypeOptions"
                                                  label="Type du diagnostique"
                                                  required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea v-model="diagnosticDescription" label="Description" required></v-textarea>
                                    </v-flex>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn
                                    :disabled="!medicalCaseInfoValid"
                                    color="success"
                                    @click="validateDiagnostic"
                                    class="right">
                                    Suivant
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-form ref="treatmentForm" v-model="treatmentInfoValid" lazy-validation>
                        <v-layout>
                            <v-flex md6 offset-md3>
                                <h3 class="headline mb-4">Traitement</h3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-menu v-model="showTreatmentDatePicker"
                                                :close-on-content-click="false"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                max-width="290px"
                                                min-width="290px">
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="dateFormatted"
                                                    label="Date de l'intervention"
                                                    append-icon="event"
                                                    v-on="on"
                                                    :rules="[v => !!v || 'Le champs est requis']"
                                                    @blur="intervention_date = parseDate(dateFormatted)"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker v-model="intervention_date" no-title locale="fr"
                                                           @input="showTreatmentDatePicker = false"></v-date-picker>
                                        </v-menu>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-select
                                            v-model="treatmentType"
                                            :items="getTreatmentTypeOptions"
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            label="Traitement"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex v-if="treatmentType && hasSubTypes(treatmentType)" xs12>
                                        <v-select
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            :items="getTreatmentSubTypeOptions[treatmentType]"
                                            v-model="treatmentSubType"
                                            label="Type"
                                            required
                                        ></v-select>
                                    </v-flex>
                                    <v-flex v-if="treatmentType && ['TREATMENT_FULL_KNEE_REPLACEMENT', 'TREATMENT_PARTIAL_KNEE_REPLACEMENT', 'TREATMENT_SURGERY'].includes(treatmentType)" xs12>
                                        <v-select
                                            :rules="[v => !!v || 'Le champs est requis']"
                                            :items="getTreatmentSurgerySideOptions[treatmentType]"
                                            v-model="treatmentSurgerySide"
                                            label="Coté opéré"
                                            required
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-select
                                            v-if="treatmentSurgerySide === 'BOTH' && false"
                                            :value="relatedTreatmentId"
                                            :items="getRelatedTreatments"
                                            @change="(value) => { setRelatedTreatmentId(value) }"
                                            label="Traitement lié"
                                            required
                                        ></v-select>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-label>Participe aux études :</v-label>
                                        <v-checkbox v-for="item in filteredStudies" :key="item.id"
                                                    hide-details
                                                    v-model="treatmentParticipantStudies"
                                                    :value="item"
                                                    :label="item.name">
                                        </v-checkbox>
                                    </v-flex>

                                    <v-flex xs12>
                                        <v-textarea v-model="treatmentDescription" label="Description" required></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                        <v-layout row mt-2>
                            <v-flex md6 offset-md3>
                                <v-btn color="success" @click="previous">
                                    Précédent
                                </v-btn>

                                <v-btn :disabled="!treatmentInfoValid" color="success" @click="validateTreatment" class="right">
                                    Suivant
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>
<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
import {getTranslationString} from "../../helper"
import DiagnosticForm from "./diagnostic/DiagnosticForm.vue";

export default {
    components: {DiagnosticForm},
    data() {
        return {
            showDatePicker: false,
            showTreatmentDatePicker: false,
            // dialog: false,
            patientInfoValid: false,
            medicalCaseInfoValid: false,
            diagnosticInfoValid: false,
            treatmentInfoValid: false,
            step: 1,
            dateFormatted: '',
            nameRules: [
                v => !!v || 'Le nom est requis'
            ],
            emailRules: [
                v => (!v || (/.+@.+\..+/.test(v))) || 'Email invalide'
            ],
            dateRules: [
                v => !!v || 'La date de naissance est requise'
            ],
            genderRules: [
                v => !!v || 'Le genre est requis',
            ],
            medicalCaseRules: [
                v => !!v || 'Le nom du cas est requis'
            ],
            opaleNumberRules: [
                v => !!v || 'Le numéro OPALE est requis'
            ],

            birthDateFormatted: '',
            newMedicalCaseName: "",
        }
    },
    computed: {
        ...mapState({
            locked: state => state.locked
        }),
        ...mapGetters('medical_cases', {
            getRelatedTreatments: 'getRelatedTreatments',
        }),
        ...mapGetters('diagnostics', ['getDiagnosticTypeOptions']),
        ...mapGetters('treatments', ['getTreatmentTypeOptions', 'getTreatmentSubTypeOptions', 'getTreatmentSurgerySideOptions']),
        ...mapState('patients', {
            selectedPatientId: state => state.selectedPatient.id,
        }),
        ...mapState('studies', {
            activeStudies: state => state.active
        }),
        ...mapState('medical_cases', {
            selectedMedicalCase: state => state.selectedMedicalCase
        }),
        filteredStudies: {
            get() {
                return this.activeStudies.filter(study => !study.block_new_patient);
            }
        },
        intervention_date: {
            get() {
                return this.$store.state.treatments.form.intervention_date
            },
            set(value) {
                this.setTreatmentInterventionDate(value)
            }
        },
        treatmentType: {
            get() {
                return this.$store.state.treatments.form.type
            },
            set(value) {
                this.setTreatmentType(value)
            }
        },
        treatmentSubType: {
            get() {
                return this.$store.state.treatments.form.sub_type
            },
            set(value) {
                this.setTreatmentSubType(value)
            }
        },
        treatmentSurgerySide: {
            get() {
                return this.$store.state.treatments.form.surgery_side
            },
            set(value) {
                this.setTreatmentSurgerySide(value)
            }
        },
        treatmentResurfacing: {
            get() {
                return this.$store.state.treatments.form.resurfacing
            },
            set(value) {
                this.setTreatmentResurfacing(value)
            }
        },
        treatmentAlignment: {
            get() {
                return this.$store.state.treatments.form.alignment
            },
            set(value) {
                this.setTreatmentAlignment(value)
            }
        },
        treatmentAlreadyOperated: {
            get() {
                return this.$store.state.treatments.form.already_operated
            },
            set(value) {
                this.setTreatmentAlreadyOperated(value)
            }
        },
        treatmentDescription: {
            get() {
                return this.$store.state.treatments.form.description
            },
            set(value) {
                this.setTreatmentDescription(value)
            }
        },
        treatmentParticipantStudies: {
                get() {
                    return this.$store.state.treatments.form.studies
                },
                set(value) {
                    this.setTreatmentParticipantStudy(value)
                }
            },
        relatedTreatmentId: {
                get() {
                    return this.$store.state.treatments.form.related_treatment_id
                },
                set(value) {
                    this.setRelatedTreatmentId(value)
                }
            },
        diagnosticType: {
            get() {
                return this.$store.state.diagnostics.form.type
            },
            set(value) {
                this.setType(value)
            }
        },
        diagnosticDescription: {
            get() {
                return this.$store.state.diagnostics.form.description
            },
            set(value) {
                this.setDescription(value)
            }
        },
        gender: {
            get() {
                return this.$store.state.patients.form.gender
            },
            set(value) {
                this.setGender(value)
            }
        },
        opaleNumber: {
            get() {
                return this.$store.state.patients.form.opale_number
            },
            set(value) {
                this.setOpaleNumber(value)
            }
        },
        declinedStudy: {
            get() {
                return this.$store.state.patients.form.declined_study
            },
            set(value) {
                this.setDeclinedStudy(value)
            }
        },
        declineDataCollection: {
            get() {
                return this.$store.state.patients.form.decline_data_collection
            },
            set(value) {
                this.setDeclineDataCollection(value)
            }
        },
        firstname: {
            get() {
                return this.$store.state.patients.form.firstname
            },
            set(value) {
                this.setFirstname(value)
            }
        },
        lastname: {
            get() {
                return this.$store.state.patients.form.lastname
            },
            set(value) {
                this.setLastname(value)
            }
        },
        birth_date: {
            get() {
                return this.$store.state.patients.form.birth_date
            },
            set(value) {
                this.setBirthDate(value)
            }
        },
        email: {
            get() {
                return this.$store.state.patients.form.email
            },
            set(value) {
                this.setEmail(value)
            }
        },
        noEmail: {
            get() {
                return this.$store.state.patients.form.no_email
            },
            set(value) {
                this.setNoEmail(value)
                this.setEmail(null)
            }
        },
        phone: {
            get() {
                return this.$store.state.patients.form.phone
            },
            set(value) {
                this.setPhone(value)
            }
        },
    },
    mounted() {
        // Reset the form
        this.birth_date = null
        this.$refs.patientForm.reset()
        this.$refs.newMedicalCaseForm.reset()
        this.$refs.diagnosticForm.reset()
        this.$refs.treatmentForm.reset()

        this.gender = ''
        this.opale_number = ''
        this.firstname = ''
        this.lastname = ''
        this.birth_date = null
        this.email = null
        this.phone = ''

        this.initDiagnosticForm()
        this.initTreatmentForm()

        this.setSelectedPatientId(null)
        this.setSelectedMedicalCaseId(null)
    },
    methods: {
        showLabel(index) {
            if (this.$refs['typeSelect_' + index]) {
                return this.$refs['typeSelect_' + index].value === "OTHER"
            }
            return false
        },
        previous() {
            this.step = this.step - 1
        },
        validate() {
            if (this.$refs.patientForm.validate()) {
                this.submit()
            }
        },
        submit() {
            this.createPatient().then(response => {
                if (response.data.state === 'new') {
                    this.setSelectedPatientId(response.data.patient)
                    this.step = 2
                } else {
                    //Move back to the user list
                    this.$router.replace({name: 'patient.view', params: {id: response.data.patient}})
                }
                // this.dialog = true
            }).catch(reason => {
                //Stay here..
            })
        },
        validateMedicalCase() {
            if (this.$refs.newMedicalCaseForm.validate()) {
                this.submitMedicalCase()
            }
        },
        submitMedicalCase() {
            if(this.selectedMedicalCase.id) {
                this.updateMedicalForm().then(response => {
                    this.step = 3
                }).catch(reason => {
                    //Stay here..
                })
            } else {
                this.createMedicalCase({
                    name: this.newMedicalCaseName,
                }).then(response => {
                    this.step = 3
                }).catch(reason => {
                    //Stay here..
                })
            }
        },
        validateDiagnostic() {
            if (this.$refs.diagnosticForm.validate()) {
                this.submitDiagnostic()
            }
        },
        submitDiagnostic() {
            this.saveDiagnostic().then(response => {
                this.step = 4
                this.getActiveStudies().then(response =>
                    this.setDefaultStudy(this.activeStudies.find(value => value.id === 1))
                )
            }).catch(reason => {
                //Stay here..
            })
        },
        validateTreatment() {
            if (this.$refs.treatmentForm.validate()) {
                this.submitTreatment()
            }
        },
        submitTreatment() {
            this.createTreatment().then(response => {
                this.$router.replace({name: 'patient.view', params: {id: this.selectedPatientId}})
            }).catch(reason => {
                //Stay here..
            })
        },
        skip() {
            this.$router.replace({name: 'patient.view', params: {id: this.selectedPatientId}})
        },
        getText(key) {
            return getTranslationString(key)
        },
        parseDate(date) {
            if (!date) return null

            const [day, month, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        hasSubTypes(type) {
            return this.getTreatmentSubTypeOptions[type] && this.getTreatmentSubTypeOptions[type].length > 0
        },
        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        ...mapMutations(['updateLockedState', 'setLockedBack']),
        ...mapMutations('patients', {
            setGender: 'setFormGender',
            setOpaleNumber: 'setFormOpaleNumber',
            setFirstname: 'setFormFirstname',
            setLastname: 'setFormLastname',
            setBirthDate: 'setFormBirthDate',
            setEmail: 'setFormQuickEmail',
            setNoEmail: 'setFormNoQuickEmail',
            setPhone: 'setFormQuickPhone',
            setSelectedPatientId: 'setSelectedPatientId',
            initPatientForms: 'initPatientForms',
        }),
        ...mapMutations('treatments', {
            setTreatmentInterventionDate: 'setFormInterventionDate',
            setTreatmentType: 'setFormType',
            setTreatmentSubType: 'setFormSubType',
            setTreatmentSurgerySide: 'setFormSurgerySide',
            setTreatmentResurfacing: 'setFormResurfacing',
            setTreatmentAlignment: 'setFormAlignment',
            setTreatmentDescription: 'setFormDescription',
            setTreatmentParticipantStudy: 'setFormParticipantStudy',
            initTreatmentForm: 'initForm',
            setDefaultStudy: 'setDefaultStudy',
            setRelatedTreatmentId: 'setFormRelatedTreatmentId',
        }),
        ...mapMutations('medical_cases', {
            setSelectedMedicalCaseId: 'setSelectedMedicalCaseId',
            setMedicalCaseName: 'setFormName',
        }),
        ...mapMutations('diagnostics', {
            setType: 'setFormType',
            setDescription: 'setFormDescription',
            setDiagnosticId: 'setFormId',
            initDiagnosticForm: 'initForm',
        }),
        ...mapActions('patients', ['createPatient', 'quickCreatePatient', 'updatePatient', 'updateContactInfos', 'loadPatientForm']),
        ...mapActions('medical_cases', ['createMedicalCase', 'getMedicalCaseInfo', 'updateMedicalForm']),
        ...mapActions('diagnostics', ['saveDiagnostic']),
        ...mapActions('treatments', ['createTreatment']),
        ...mapActions('studies', ['getActiveStudies']),
    },
    watch: {
        showDatePicker(val) {
            this.birth_date ? val : (val && setTimeout(() => (this.$refs.birthdayPicker.activePicker = 'YEAR')))
        },
        birth_date(date) {
            this.birthDateFormatted = date ? this.$options.filters.formatedDate(date) : ''
        },
        intervention_date(date) {
            this.dateFormatted = date ? this.$options.filters.formatedDate(date) : ''
        },
        studiesForm: {
            handler(val) {
                console.log(this.studiesForm, val)
                // this.$store.commit('treatments/setFormStudies', this.studiesForm)
            },
            deep: true
        }


    },
}
</script>

<style scoped>

</style>
